// Tour step definitions for each page
// target: CSS selector (data-testid preferred)
// title: Short step title
// description: What the user should know

export const DASHBOARD_TOUR = {
  id: 'dashboard',
  steps: [
    {
      target: '[data-testid="stats-total-leads"]',
      title: 'Your Key Metrics',
      description: 'These cards show your most important numbers at a glance — total leads, new leads, converted deals, and team activity.',
    },
    {
      target: '[data-testid="team-activity-feed"]',
      title: 'Team Activity Feed',
      description: 'See real-time updates when teammates share leads, convert deals, or new members join. Events stream in live!',
    },
    {
      target: 'a[href="/leads"]',
      title: 'Manage Your Leads',
      description: 'Head to Leads to create, share, and track all your business contacts. Use filters, Kanban view, and bulk operations.',
    },
    {
      target: 'a[href="/appointments"]',
      title: 'Schedule Appointments',
      description: 'Use the Calendar to schedule meetings with attendees, set reminders, and link appointments to leads.',
    },
  ],
};

export const LEADS_TOUR = {
  id: 'leads',
  steps: [
    {
      target: '[data-testid="add-lead-btn"]',
      title: 'Create a Lead',
      description: 'Click here to add a new lead. Fill in name, email, phone, company, address, and more. The system checks for duplicates automatically.',
    },
    {
      target: '[data-testid="search-leads-input"]',
      title: 'Search & Filter',
      description: 'Search by name, email, company, or phone. Use the status and category dropdowns, or click "Filters" for advanced options like score, date range, and saved filters.',
    },
    {
      target: '[data-testid="view-mode-toggle"]',
      title: 'Table & Kanban Views',
      description: 'Switch between Table view (sortable columns) and Kanban view (drag-and-drop pipeline). Use whichever fits your workflow.',
    },
    {
      target: '[data-testid="export-leads-btn"]',
      title: 'Import & Export',
      description: 'Export leads as CSV, or import from a CSV file. Use "CRM Import" for advanced field mapping from Salesforce, HubSpot, etc.',
    },
    {
      target: '[data-testid="scan-duplicates-btn"]',
      title: 'Scan for Duplicates',
      description: 'Admin feature: scan your entire lead database for duplicates. Review clusters, pick a primary lead, and merge them in bulk.',
    },
  ],
};

export const LEAD_DETAIL_TOUR = {
  id: 'lead-detail',
  steps: [
    {
      target: '[data-testid="lead-score-badge"]',
      title: 'Lead Score',
      description: 'Each lead gets a score based on notes, shares, documents, appointments, and recent activity. Hot leads (40+) are your best bets.',
    },
    {
      target: '[data-testid="lead-notes-section"]',
      title: 'Notes & Timeline',
      description: 'Add notes to track interactions. All activity (shares, edits, document uploads) is logged in the timeline below.',
    },
    {
      target: '[data-testid="lead-documents-section"]',
      title: 'Documents',
      description: 'Upload contracts, proposals, or any file up to 25MB. Documents are shared with everyone who has access to this lead.',
    },
  ],
};

export const CALENDAR_TOUR = {
  id: 'calendar',
  steps: [
    {
      target: '[data-testid="view-mode-tabs"]',
      title: 'Calendar Views',
      description: 'Switch between Month, Week, and Agenda views. Month shows dots on days with appointments. Agenda lists everything upcoming.',
    },
    {
      target: '[data-testid="create-appointment-btn"]',
      title: 'Schedule Appointments',
      description: 'Create appointments with a title, date, time, duration, attendees, and optional lead link. Set reminders and recurring schedules.',
    },
  ],
};
